export const SIMULATION_YEARS_TABLE_COLUMNS = [
  {
    id: 'Year',
    title: 'Year',
    dataIndex: 'Year',
  },
  {
    id: 'FortuitousEventsProbability',
    title: 'Fortuitous Events',
    render: row =>
      row.FortuitousEventsRandomAndInvisible
        ? 'Random'
        : `${Math.round(row.FortuitousEventsProbability * 100)}%`,
  },
  {
    id: 'DisastrousEventsProbability',
    title: 'Disastrous Events',
    render: row =>
      row.DisastrousEventsRandomAndInvisible ? 'Random' : `${Math.round(row.DisastrousEventsProbability * 100)}%`,
  },
];
